import { Fund } from '../types';
import { useUpdate } from '@refinedev/core';

export const useUpdateFund = () => {
  const { mutateAsync, isLoading } = useUpdate<Fund>();

  const updateFund = async (fund: Partial<Fund> & { id: string }) => {
    return mutateAsync({
      resource: 'funds',
      id: fund.id,
      values: fund,
    });
  };

  return {
    updateFund,
    isLoading,
  };
};
